import { COREAPI } from '../../../constants/global';
import { locationType } from '../../types';
import * as utils from '../utils';
import type { IResponse } from './election';

export const postLocation_Location = ({
	data,
	onSuccess,
	onFailure,
}: IResponse & {
	data: {
		latitude: number;
		longitude: number;
		accuracy: number;
		timestamp: string;
		entityCode?: string;
	};
}) =>
	utils.httpPostMethod({
		apiData: {
			customurl: `${COREAPI}/api/v1/track`,
			url: '',
			header: utils.header(),
			data,
		},
		actionType: locationType.postLocation_Location,
		onSuccess,
		onFailure,
	});
